// extracted by mini-css-extract-plugin
module.exports =  {"indicator-container":"indicator-container-wgAZn","indicator":"indicator-jM65y"};